/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Valid values for a sort in a Query
 */
export enum BioSamplingContainerSortFieldsV1 {
    CONTAINER_CODE = 'CONTAINER_CODE',
    CONTAINER_NUMBER = 'CONTAINER_NUMBER',
    KIT_CODE = 'KIT_CODE',
    KIT_TYPE = 'KIT_TYPE',
    PRACTICE_CODE = 'PRACTICE_CODE',
    EVENT_ID = 'EVENT_ID',
    CREATION_DATE = 'CREATION_DATE',
    LAST_MODIFIED = 'LAST_MODIFIED',
}